module.exports = __webpack_public_path__ + "img/thumb_2020-02.a25aac93.jpg";